import Hero from "../components/Hero";
import ToolsMarquee from "../components/ToolsMarquee";
import Expertise from "../components/Expertise";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Contact from "../components/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <ToolsMarquee />
      <Expertise />
      <Projects />
      <Experience />
      <Contact />
    </>
  );
}
